/* eslint-disable */
// @ts-nocheck
export const sendGoogleEvent = (
  propertyId1: string | undefined,
  propertyId2: string | undefined,
  conversionId: string,
  pageId: string,
): void => {
  if (typeof gtag === "undefined") {
    const script = document.createElement("script");
    document.head.appendChild(script);
    script.src = `https://www.googletagmanager.com/gtag/js?id=${propertyId1}`;
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    // Not currently being set in syndication client side tracking
    // leaving comment here for reference if we need to add this later
    // gtag('set', 'allow_ad_personalization_signals', false);
    gtag("js", new Date());
    if (propertyId1) {
      gtag("config", propertyId1, { send_page_view: true });
    }
    if (propertyId2) {
      gtag("config", propertyId2, { send_page_view: true });
    }
  }
  if (conversionId) {
    gtag("event", "conversion", {
      send_to: conversionId,
      transaction_id: pageId,
    });
  }
};
